import React from 'react'

export const SurinkIcon: React.FC = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17.5 10L27.4593 22.75H7.54071L17.5 10Z' fill='currentColor' />
  </svg>
)
